import dataLayer from '@helpers/dataLayer';
import { CountryItem, SublistItem } from '@type/common';

export const setURLfromFilters = (f: {
  country?: string;
  countryId: string;
  officeType?: string;
  officeTypeId: string;
  zipcode: string;
  isFilter: boolean;
  countryName: string;
  officeName: string;
}) => {
  const url: any = new URL(window.location.toString());
  url.searchParams.set('countryId', f.country || f.countryId);
  url.searchParams.set('officeTypeId', f.officeType || f.officeTypeId);
  url.searchParams.set('zipcode', f.zipcode);
  url.searchParams.set('isFilter', f.isFilter);

  dataLayer.push('find_contact_search', {
    find_contact_country: f.countryName,
    find_contact_type: f.officeName,
  });

  window.location = url;
};

export const getFiltersFromURL = () => {
  const url = new URL(window.location.toString());
  let zipcode = url.searchParams.get('zipcode');
  if (zipcode == null || zipcode == 'null') zipcode = '';
  return {
    countryId: getCountryIdFromUrl(url),
    officeTypeId: getOfficeIdFromUrl(url),
    zipcode,
    isFilter: url.searchParams.get('isFilter'),
  };
};

export const getItemFromSubList = (id: string, list: CountryItem[], subListName: string) => {
  let returnItem = null;

  list?.forEach((item) => {
    item[subListName]?.forEach((subListItem) => {
      if (parseInt(subListItem?.Id) === parseInt(id)) returnItem = subListItem;
    });
  });

  return returnItem;
};

export const getItemFromList = (id: string, list: SublistItem[]) => {
  let returnItem = null;

  list.forEach((item) => {
    if (parseInt(item.Id) === parseInt(id)) returnItem = item;
  });
  return returnItem;
};

const getCountryIdFromUrl = (url: URL) => {
  const countryId = url.searchParams.get('countryId');
  return countryId && countryId != ''
    ? countryId == '2000'
      ? '2000'
      : countryId
    : window.countryId;
};

const getOfficeIdFromUrl = (url: URL) => {
  const officeTypeId = url.searchParams.get('officeTypeId');
  return officeTypeId || '0';
};

export const findOfficeNameById = (
  officeTypeId: string,
  offices = [] as { Id: string; Name: string }[],
  defaultValue: string,
  select: string
): string => {
  let officeName = '';
  offices.forEach((office) => {
    if (office.Id == officeTypeId) {
      officeName = office.Name;
    }
  });
  return officeName != '' ? officeName : officeTypeId == '-1' ? select : defaultValue;
};
